import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import HistoryList from "./HistoryList";


const CollapsibleHistory = ({ formData, callNotingDetailsAPI, developerRemarks, setDeveloperRemarks, notingRemarksData, logoData }) => {
  const [open4, setOpen4] = useState(true);

  return (
    <div>
      <div
        className="collapse-header"
        onClick={() => setOpen4(!open4)}
        aria-controls="example-collapse-text"
        aria-expanded={open4}
        style={{
          background: "rgba(52, 73, 94, 0.94)",
          padding: "0.25rem 1.25rem",
          borderRadius: "0.25rem",
          fontWeight: "600",
          display: "flex",
          cursor: "pointer",
          color: "#817f7f",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >
        <span style={{ color: "#fff", fontSize: 16 }}>
          Add Noting
        </span>

        {open4 ? <RemoveIcon sx={{ color: '#fff' }} /> : <AddIcon sx={{ color: '#fff' }} />}
      </div>
      <Collapse in={open4}>
        <div
          id="example-collapse-text"
          style={{
            marginTop: 12,
            paddingLeft: 12,
            paddingRight: 12,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "flex",
              marginBottom: 2,
              marginTop: 3,
            }}
          >
            <HistoryList formData={formData} callNotingDetailsAPI={callNotingDetailsAPI} developerRemarks={developerRemarks} setDeveloperRemarks={setDeveloperRemarks} notingRemarksData={notingRemarksData} logoData={logoData}/>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleHistory;

